function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from "prop-types";
import TagsField from "./TagsField";

const TagsWidget = (_ref) => {
  let id = _ref.id,
      disabled = _ref.disabled,
      readonly = _ref.readonly,
      options = _ref.options,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      autofocus = _ref.autofocus,
      onChange = _ref.onChange,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "disabled", "readonly", "options", "value", "autofocus", "onChange"]);

  const enumOptions = options.enumOptions,
        enumDisabled = options.enumDisabled;
  const label = options.title || props.title || props.label || "bool";
  const placeholder = options.placeholder || null;
  const helperText = options.help || null;
  const autocompleteOptions = enumOptions.map((option, index) => {
    const selected = value.indexOf(option.value) !== -1;
    const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
    return {
      label: option.label,
      value: option.value,
      disabled: disabled || itemDisabled || readonly
    };
  });
  return React.createElement(TagsField, _extends({}, props, {
    disabled: disabled || readonly,
    label: label,
    placeholder: placeholder,
    helperText: helperText,
    value: value,
    options: autocompleteOptions,
    onChange: onChange
  }));
};

TagsWidget.defaultProps = {
  autofocus: false,
  options: {
    inline: false
  }
};
TagsWidget.propTypes = process.env.NODE_ENV !== "production" ? {
  schema: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  options: PropTypes.shape({
    enumOptions: PropTypes.array,
    inline: PropTypes.bool
  }).isRequired,
  value: PropTypes.any,
  required: PropTypes.bool,
  readonly: PropTypes.bool,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  autofocus: PropTypes.bool,
  onChange: PropTypes.func
} : {};
export default TagsWidget;